import { Controller } from "@hotwired/stimulus"

const SDK_ID = "featurebase-sdk"

let sdkQueued = false
let widgetInitialized = false
let lastJwt = null

export default class extends Controller {
  static values = {
    organization: String,
    jwt: String,
    theme: String,
    sdkUrl: String,
  }

  connect() {
    this.ensureSdk()
    this.boot()
  }

  ensureSdk() {
    if (typeof window.Featurebase !== "function") {
      window.Featurebase = function () {
        ;(window.Featurebase.q = window.Featurebase.q || []).push(arguments)
      }
    }

    if (document.getElementById(SDK_ID) || sdkQueued) return

    sdkQueued = true
    const script = document.createElement("script")
    script.id = SDK_ID
    script.async = true
    script.src = this.sdkUrlValue
    document.head.appendChild(script)
  }

  boot() {
    const jwt = this.jwtValue
    if (jwt && jwt !== lastJwt) {
      // identify — not boot. boot mounts Featurebase Messenger and shows its
      // bottom-corner launcher even with messenger:false (CORE-9260).
      window.Featurebase("identify", {
        organization: this.organizationValue,
        featurebaseJwt: jwt,
      })
      lastJwt = jwt
    }

    if (widgetInitialized) return

    // Omit placement so Featurebase does not render a floating feedback button.
    // Request feature uses data-featurebase-feedback on the header menu item.
    window.Featurebase("initialize_feedback_widget", {
      organization: this.organizationValue,
      theme: this.themeValue,
      featurebaseJwt: jwt,
    })
    widgetInitialized = true
  }
}
